export enum AntivirusStatus {
	CLEAN = 'CLEAN',
	ERROR = 'ERROR',
	INFECTED = 'INFECTED',
	PENDING = 'PENDING',
}

export enum FileType {
	ASSET = 'ASSET',
	ATTACHMENT = 'ATTACHMENT',
	PRINTFILE = 'PRINTFILE',
}

export enum PreflightError {
	PIPELINE_ERROR = 'PIPELINE_ERROR',
	UNSUPPORTED_FILE_TYPE = 'UNSUPPORTED_FILE_TYPE',
}

export enum PreflightStatus {
	ERROR = 'ERROR',
	NOT_PRINTABLE = 'NOT_PRINTABLE',
	PENDING = 'PENDING',
	PRINTABLE = 'PRINTABLE',
}
